module.exports = __webpack_public_path__ + "img/6m.5a775fca.jpg";